import { render } from "./movtiny-list.vue?vue&type=template&id=7d2bd912"
import script from "./movtiny-list.vue?vue&type=script&lang=js"
export * from "./movtiny-list.vue?vue&type=script&lang=js"

import "./movtiny-list.vue?vue&type=style&index=0&id=7d2bd912&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__